module.exports = __webpack_public_path__ + "media/images/pages/calendar-8c7eb8698a5f2273c373adfe20da1092.svg";